module.exports = __webpack_public_path__ + "img/symbol_arrow1yellow.5f3dfdaa.png";